import React, { Fragment, useEffect, } from 'react';
import { FormGroup, Input, Label, } from 'reactstrap';

export default function DataToggle (props) {
  const { label, data, fieldName, inputProps, labelProps, onFinish = _ => _, } = props;
  const onChange = async (event) => {
    await data.ref.update({ [fieldName]: event.target.checked });
    await onFinish();
  };

  return (
    <FormGroup check>
      <Label check>
        <Input type="checkbox" checked={!!data[fieldName]} onChange={onChange} {...inputProps} />
        <span {...labelProps}>{label}</span>
      </Label>
    </FormGroup>
  );
};
